import { render } from "./QcTask.vue?vue&type=template&id=4c77a4af&scoped=true"
import script from "./QcTask.vue?vue&type=script&lang=js"
export * from "./QcTask.vue?vue&type=script&lang=js"

import "./QcTask.vue?vue&type=style&index=0&id=4c77a4af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c77a4af"]])

export default __exports__